<div
  class="upload-drop-area rich-text-edit-upload"
  appUploadDrop
  [disableAppUploadDrop]="!allowFileUpload"
  (fileDropped)="emitUploadFiles($event)"
>
  <div class="rte-container">
    <div class="editor-scroll-container">
      <tiptap-editor
        class="editor"
        [class.editor-mode]="theme === 'editor'"
        [editor]="editor"
        [ngModel]="_editorValue"
        (ngModelChange)="emitEditorValueChange($event)"
      ></tiptap-editor>
    </div>

    <div class="editor-menu-container" [class.editor-mode]="theme === 'editor'">
      <div class="editor-menu">
        <div
          aria-hidden="true"
          class="icon btn icon-bold pointer-cursor"
          (click)="editor.chain().focus().toggleBold().run()"
          [class.icon-active]="editor.isActive('bold')"
          matTooltip="Insert Bold"
          matTooltipShowDelay="1000"
        ></div>

        <div
          aria-hidden="true"
          class="icon btn icon-italic pointer-cursor"
          (click)="editor.chain().focus().toggleItalic().run()"
          [class.icon-active]="editor.isActive('italic')"
          matTooltip="Insert Italic"
          matTooltipShowDelay="1000"
        ></div>

        <div
          aria-hidden="true"
          class="icon btn icon-underline pointer-cursor"
          (click)="editor.chain().focus().toggleUnderline().run()"
          [class.icon-active]="editor.isActive('underline')"
          matTooltip="Insert Underline"
          matTooltipShowDelay="1000"
        ></div>

        <div class="ml-3 flex items-center">
          @if (showLinkInput) {
            <app-placeholder-input
              (keyDown.enter)="confirmLink()"
              class="relative !w-56 !h-8 !pr-9"
              [(model)]="linkInputValue"
              name="link"
              placeholder="URL"
            >
              <div icon class="absolute top-1/2 -translate-y-1/2 right-1 flex items-center justify-center">
                <div
                  aria-hidden="true"
                  class="icon-approved text-green-400 cursor-pointer"
                  (click)="confirmLink()"
                ></div>
                <div
                  aria-hidden="true"
                  class="icon-remove-circle-x text-red-600 cursor-pointer"
                  (click)="discardLink()"
                ></div>
              </div>
            </app-placeholder-input>
          } @else {
            <div
              aria-hidden="true"
              class="icon btn icon-link pointer-cursor"
              (click)="openLinkInput()"
              [class.icon-active]="editor.isActive('link')"
              matTooltip="Insert Link"
              matTooltipShowDelay="1000"
            ></div>
          }
        </div>

        @if (allowFileUpload) {
          <app-upload-window
            #uploadWindow
            (chosenFiles)="emitUploadFiles($event)"
            [allowMultipleFiles]="true"
            class="ml-3 relative pointer-cursor"
          >
            <div
              matTooltip="Upload Files"
              matTooltipShowDelay="1000"
              (click)="uploadWindow.openWindow()"
              aria-hidden="true"
              class="icon btn icon-upload-square"
            ></div>
          </app-upload-window>
        }
      </div>
      <div>
        <ng-content select=".right-button-container"></ng-content>
      </div>
    </div>
  </div>

  @if (filesToUpload.length) {
    <div class="upload-container">
      <ng-scrollbar class="std-scrollbar" orientation="vertical" appearance="native">
        @for (fileToUpload of filesToUpload; track fileToUpload; let index = $index) {
          <div class="upload-item">
            <div class="text-navy-700 flex-1 ml-1.5">
              {{ fileToUpload.file.name | removeFileExtension | shortenFileName: 18 }}
            </div>
            <div class="relative w-7 h-full">
              <i
                aria-hidden="true"
                (click)="emitRemoveFileToUpload(fileToUpload, index)"
                class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 cursor-pointer text-blue-700 icon-minus-box"
              ></i>
            </div>
          </div>
        }
      </ng-scrollbar>
    </div>
  }
</div>
